<template>
  <b-card>
    <div
      style="min-height:760px"
    >
      <div
        v-if="show"
        class="search"
      >
        <el-input
          v-model="input"
          placeholder="请输入学生姓名/学号查询"
          style="width:500px;font-size:22px;"
        />
        <el-button
          type="primary"
          class="ml-1 w-auto"
          @click="search"
        >搜 索</el-button>
      </div>
      <div v-if="!show">
        <el-row>
          <el-col align="right">
            <el-button
              type="primary"
              @click="queryAgain"
            >重 新 查 询</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <h3>当前在岗情况</h3>
          </el-col>
          <el-col :span="24">
            <el-table
              :data="nowTableDate"
              border
              max-height="240"
            >
              <el-table-responsive-column
                prop="name"
                label="姓名"
                width="180"
              />
              <el-table-responsive-column
                prop="sn"
                label="学号"
              />
              <el-table-responsive-column
                prop="college"
                label="学院"
                :show-overflow-tooltip="true"
              />
              <el-table-responsive-column
                prop="major"
                label="专业"
              />
              <el-table-responsive-column
                prop="clazz"
                label="班级"
              />
              <el-table-responsive-column
                prop="jobType"
                label="岗位类型"
              />
              <el-table-responsive-column
                prop="jobTime"
                label="在岗时间"
              />
              <el-table-responsive-column
                prop="unitName"
                label="设岗单位"
              />
              <el-table-responsive-column
                prop="jobName"
                label="岗位名称"
              />
              <el-table-responsive-column
                prop="realMoney"
                label="岗位工资"
              />
            </el-table>
          </el-col>
          <!-- <el-col :span="24"
                  v-if='nowTableDate.length===0'>
            <p>未查询到当前在岗信息</p>
          </el-col> -->
        </el-row>
        <el-row style="margin-top:60px">
          <el-col>
            <h3>历史在岗情况</h3>
          </el-col>
          <el-col :span="24">
            <el-table
              :data="historyTableDate"
              border
              class="responsive"
            >
              <el-table-responsive-column
                prop="name"
                label="姓名"
                width="180"
              />
              <el-table-responsive-column
                prop="sn"
                label="学号"
              />
              <el-table-responsive-column
                prop="college"
                label="学院"
                :show-overflow-tooltip="true"
              />
              <el-table-responsive-column
                prop="major"
                label="专业"
              />
              <el-table-responsive-column
                prop="clazz"
                label="班级"
              />
              <el-table-responsive-column
                prop="jobType"
                label="岗位类型"
              />
              <el-table-responsive-column
                prop="jobTime"
                label="在岗时间"
              />
              <el-table-responsive-column
                prop="unitName"
                label="设岗单位"
              />
              <el-table-responsive-column
                prop="jobName"
                label="岗位名称"
              />
              <el-table-responsive-column
                prop="realMoney"
                label="岗位工资"
              />
            </el-table>
          </el-col>
        </el-row>
      </div>
    </div>
  </b-card>
</template>

<script>
import { unitService } from '@/api/index'
import { checkInput } from '@/tool/utils'

export default {
  name: 'Index',
  data() {
    return {
      input: '',
      show: true,
      nowTableDate: [],
      historyTableDate: [],
    }
  },
  methods: {
    search() {
      if (checkInput(this.input)) {
        this.show = false
        this.nowTableDate = []
        this.historyTableDate = []
        unitService()._queryEmploymentInformation(this.input).then(res => {
          if (res.status) {
            this.nowTableDate = res.data.nowUnitJob
            this.historyTableDate = res.data.historyUnitJob
          }
        })
      } else {
        this.$message.warning('请输入正确格式')
      }
    },
    queryAgain() {
      this.show = true
      this.input = ''
    },
  },
}
</script>
<style lang="less">
@import "../../styles/var";
.breadCream-box {
  .breadCream-box();
}
.content-box {
  .content-box();
}

.search {
  display: flex;
  justify-content: center;
  margin-top: 300px;
  .el-input--small .el-input__inner {
    height: 80px;
  }
}
</style>
